import { render, staticRenderFns } from "./ContentMiniCard.vue?vue&type=template&id=151c5310&scoped=true&"
import script from "./ContentMiniCard.vue?vue&type=script&lang=ts&"
export * from "./ContentMiniCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContentMiniCard.vue?vue&type=style&index=0&id=151c5310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c5310",
  null
  
)

export default component.exports